@if (isCustomizationSelected) {
	<div class="customization-border">
		<h2 class="customization-att-title">Review Your Customization</h2>
		<button class="edit-customization" (click)="openEditCustomPanel()">
			<span class="hmf-p-0">Edit Customizations</span>
		</button>
		<ul class="customization-element">
			@for (dataElement of customizedAttributes; track trackByFn($index, dataElement)) {
				<li>
				<homefield-icon
					width="14px"
					height="14px"
					name="sign-circled-check-outline"
					fill="var(--hmf-scgreen)">
				</homefield-icon>
				<span class="custom-attr-name">{{dataElement.name}}</span>: &nbsp;{{dataElement.value}}
			</li>
			}
		</ul>
	</div>
}
